import React from 'react'

const Services = () => {
  return (
    <div>
      <h1>Our Services page</h1>
    </div>
  )
}

export default Services
